var _circle, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#5F98D1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m415.81 147.47h-320.26l116.02 120.81 33.48 33.9c-18.216-4.164-19.343-6.759-27.415-13.349-4.234-3.457-12.414-12.852-24.838-25.54-38.781-39.601-104.59-106.8-104.59-106.8v198.82l8.265 8.265-0.925 0.963 147.12 147.12c4.412 0.226 8.852 0.343 13.32 0.343 141.38 0 256-114.62 256-256 0-4.246-0.11-8.466-0.313-12.661l-95.874-95.873z",
    fill: "#3A6DA1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "88.217 156.48 88.217 355.31 185.18 255.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.78 156.48 423.78 355.31 327.31 255.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.558 147.47h320.26l-125.86 131.06c-8.958 9.327-21.331 14.599-34.262 14.599s-25.304-5.272-34.262-14.599l-125.87-131.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.21 285.5c-10.799 11.244-25.933 17.694-41.523 17.694-15.589 0-30.724-6.448-41.522-17.693l-21.349-22.23-97.257 101.27h320.26l-97.256-101.27-21.348 22.229z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.0de4e96bf34b7086d8081851a18ae480.svg";
export { ForwardRef as ReactComponent };